/* ============
 * Create Page
 * ============
 *
 * This is the page for adding product group.
 */
import { mapGetters } from 'vuex';
import productGroupService from './../../../../services/product-group';
import exciseGroupService from './../../../../services/exciseGroup';
import productGroupTransformer from './../../../../transformers/productGroup';
import Forms from './../../../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        description: {
          value: '',
          type: 'textarea',
        },
        parentGroupId: {
          value: '',
          type: 'select',
        },
        // exciseDutyId: {
        //   value: '',
        //   type: 'select',
        // },
      }),
    };
  },

  created() {
    Promise.all([
      productGroupService.all(),
      exciseGroupService.all(),
    ]).then(() => {
      this.loading = false;
    });
  },

  computed: {
    isInOwnRoute() {
      return this.$route.name === 'productGroups.create';
    },
    ...mapGetters({
      productGroups: 'allProductGroups',
      groups: 'allExciseGroups',
    }),
  },

  methods: {
    /**
     * Method to store the product group.
     */
    store() {
      this.form.loading = true;
      const productGroup = productGroupTransformer.send(this.form.data());
      productGroupService.store(productGroup)
        .then(() => {
          this.form.loading = false;
          if (this.isInOwnRoute) {
            this.$message({
              message: this.$t('static.productGroups.create.success'),
              type: 'success',
            });
            this.$router.push({
              name: 'productGroups.index',
            });
          } else {
            this.$emit('close');
            productGroupService.all();
          }
        }).catch((errors) => {
          this.form.loading = false;
          this.form.recordErrors(errors);
        });
    },
  },

  watch: {
    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} productGroups The product groups list.
     */
    /* eslint max-len: ["error", 150] */
    productGroups(productGroups) {
      this.form.setOptions('parentGroupId', productGroups.all);
    },

    duties(duties) {
      this.form.setOptions('exciseDutyId', duties.map(c => ({ id: c.id, name: `${c.title }` })));
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/productGroups/create/create.js